import React, { Component } from 'react';
import styled from 'styled-components';

import { Grid, Row } from 'react-bootstrap';
import { DayNightButton } from '../StyledPrimitives/StyledPrimitives';
import TimeColoredCenteredCol from './TimeColoredCenteredCol';
import JobsList from './JobsList';

const PaddedCol = styled(TimeColoredCenteredCol)`
    padding: 10px 0;
`;

class TimeToggledJobsContent extends Component {
    state = {
        isShowingDayJob: true
    }

    buttonClicked = () => {
        this.setState({isShowingDayJob: !this.state.isShowingDayJob});
    }

    render() {
        return (
            <Grid fluid>
                <Row>
                    <PaddedCol isDay={this.state.isShowingDayJob} sm={12}>
                        <DayNightButton isDay={this.state.isShowingDayJob} onClick={this.buttonClicked}>{this.state.isShowingDayJob ? 'Switch to Night Job' : 'Switch to Day Job'}</DayNightButton>
                    </PaddedCol>
                </Row>
                <Row>
                    <TimeColoredCenteredCol isDay={this.state.isShowingDayJob} sm={12}>
                        <JobsList isDay={this.state.isShowingDayJob}/>
                    </TimeColoredCenteredCol>
                </Row>
            </Grid>
        );
    }
};

export default TimeToggledJobsContent;


// WEBPACK FOOTER //
// ./src/components/Job/TimeToggledJobsContent.js